import { Link } from 'react-router'
import { Activity } from 'lucide-react'
import { ChartCard, ActivityFeed } from '@/components/common'
import { Skeleton } from '@/components/ui/skeleton'
import { EmptyState } from '@/components/common/EmptyState'
import { useRecentActivities } from '../api'

/** The activity feed, with relative timestamps. */
export function RecentActivitiesCard() {
  const { data, isLoading } = useRecentActivities(6)

  return (
    <ChartCard
      title="Recent Activities"
      icon={Activity}
      filter={
        <Link to="/administration" className="text-xs font-medium text-[var(--color-primary)] hover:underline">
          View All
        </Link>
      }
    >
      {isLoading && (
        <div className="space-y-3 py-2">
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} className="h-8 w-full" />
          ))}
        </div>
      )}

      {data && data.length === 0 && (
        <EmptyState title="No activity yet" description="Actions across the system appear here." />
      )}

      {data && data.length > 0 && (
        <ActivityFeed
          className="py-1"
          items={data.map((entry) => ({
            id: entry.id,
            type: entry.type,
            message: entry.message,
            occurredAt: entry.occurredAt,
            actorName: entry.actorName,
          }))}
        />
      )}
    </ChartCard>
  )
}
